import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap-5';
import { startBulkDeleteTasks, startBulkRemoveTasks } from './store/actions/tasks';

export class ActionsDropdown extends React.Component {
  static propTypes = {
    selectedTaskIds: PropTypes.array.isRequired,
    onBulkDeleteTasks: PropTypes.func.isRequired,
    onBulkRemoveTasks: PropTypes.func.isRequired,
    onDeleteCallList: PropTypes.func.isRequired,
    onRenameCallList: PropTypes.func.isRequired
  };

  render() {
    const {
      selectedTaskIds,
      onBulkDeleteTasks,
      onBulkRemoveTasks,
      onRenameCallList,
      onDeleteCallList
    } = this.props;

    const itemsForSelections = selectedTaskIds.length > 0;

    return (
      <Dropdown
        className="actions-dropdown"
        key="call-list-actions-dropdown"
        name="call-list-actions-dropdown"
      >
        <Dropdown.Toggle className="btn btn-secondary">
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {itemsForSelections &&
            <>
              <Dropdown.Item id='remove-tasks' key='remove-tasks' onClick={onBulkRemoveTasks}>
                Remove Task(s) From Call List
              </Dropdown.Item>
              <Dropdown.Item id='delete-calls' key='delete-calls' onClick={onBulkDeleteTasks}>
                Delete Task(s)
              </Dropdown.Item>
            </>
          }
          <Dropdown.Item id='rename-call-list' key='rename-call-list' onClick={onRenameCallList}>
            Rename Call List
          </Dropdown.Item>
          <Dropdown.Item id='delete-call-list' key='delete-call-list' onClick={onDeleteCallList}>
            Delete Call List
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => ({
  selectedTaskIds: state.selectList.selectedTaskIds
});

const mapDispatchToProps = {
  onBulkDeleteTasks: startBulkDeleteTasks,
  onBulkRemoveTasks: startBulkRemoveTasks
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionsDropdown);
